import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlug } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faInstagram, faXTwitter, faYoutube, faLinkedinIn, faWhatsapp, faTiktok } from '@fortawesome/free-brands-svg-icons';

const FooterPage = () => {
    return (
        <footer className="bg-dark text-white pt-4 pb-3 mt-5">
            <Container>
                <Row className="mb-3">
                    <Col lg={6} md={12} className="text-center text-lg-start mb-3">
                        <h5 className="text-white mb-3">PluginTech</h5>
                        <p className="text-light small">
                            Rua Nova Esperança, n° 1697, Sítio Cercado, Curitiba - PR 81925-550, BR
                        </p>
                        <p className="text-light small mb-0">
                            <a href="tel:+5541997825871" className="text-light text-decoration-none me-3">
                                (41) 9 9782-5871
                            </a>
                            <a href="mailto:tecnico@plugintech.com.br" className="text-light text-decoration-none">
                                tecnico@plugintech.com.br
                            </a>
                        </p>
                    </Col>
                    
                    <Col lg={6} md={12} className="text-center text-lg-end">
                        <h6 className="text-white mb-3">Siga-nos</h6>
                        <div className="social-links">
                            <a href="https://www.facebook.com/plugintechbr" target="_blank" rel="noopener noreferrer" className="text-white me-3">
                                <FontAwesomeIcon icon={faFacebookF} size="lg" className="social-icon"/>
                            </a>
                            <a href="https://twitter.com/plugintech_br" target="_blank" rel="noopener noreferrer" className="text-white me-3">
                                <FontAwesomeIcon icon={faXTwitter} size="lg" className="social-icon"/>
                            </a>
                            <a href="https://www.instagram.com/plugintechbr" target="_blank" rel="noopener noreferrer" className="text-white me-3">
                                <FontAwesomeIcon icon={faInstagram} size="lg" className="social-icon"/>
                            </a>
                            <a href="https://www.tiktok.com/@plugintechbr" target="_blank" rel="noopener noreferrer" className="text-white me-3">
                                <FontAwesomeIcon icon={faTiktok} size="lg" className="social-icon"/>
                            </a>
                            <a href="https://www.linkedin.com/company/plugintech" target="_blank" rel="noopener noreferrer" className="text-white me-3">
                                <FontAwesomeIcon icon={faLinkedinIn} size="lg" className="social-icon" />
                            </a>
                            <a href="https://www.youtube.com/@plugintechBr" target="_blank" rel="noopener noreferrer" className="text-white me-3">
                                <FontAwesomeIcon icon={faYoutube} size="lg" className="social-icon"/>
                            </a>
                            <a href="https://api.whatsapp.com/send?phone=5541997825871&text=Ol%C3%A1%2C%20estou%20entrando%20em%20contato%20pelo%20site%20Plugintech!%20" target="_blank" rel="noopener noreferrer" className="text-white">
                                <FontAwesomeIcon icon={faWhatsapp} size="lg" className="social-icon"/>
                            </a>
                        </div>
                    </Col>
                </Row>
                
                <hr className="bg-white opacity-25" />
                
                <Row>
                    <Col className="text-center">
                        <span className="small">© 2025 Plugintech <FontAwesomeIcon icon={faPlug} className="ms-1" /></span>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
};

export default FooterPage;